import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'
import '../../plant-style.scss'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import {
  FetchGraphBysortNew,
  FetchDeviceStatusNew,
  fetchGraphV2Data,
} from '../../../../services/api'
import dayjs from 'dayjs'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { saveAs } from 'file-saver'

import useInverterViewGraphStyles from './styles'
import { LinearBuffer } from '../utils/LinearBuffer'

const InverterViewGraph = ({ state, token }) => {
  const classes = useInverterViewGraphStyles()

  const [technicalFromDate, setTechnicalFromDate] = React.useState(
    dayjs(new Date()).subtract(29, 'day')
  )
  const [technicalToDate, setTechnicalToDate] = React.useState(
    dayjs(new Date())
  )
  const [mapinverterData, setMapinverterData] = React.useState([])
  const [mapInverterSeries, setMapInverterSeries] = React.useState([])
  const [inverterviewbutton, setinverterviewbutton] = useState('1m')
  const [graphType, setGraphType] = useState('Inverter')
  const [inverterCount, setInverterCount] = React.useState(1)
  const [selectedDeviceID, setSelectedDeviceID] = useState('inverter-1')
  const [selectedTypeID, setSelectedTypeID] = useState(1)
  const [selectedButtons, setSelectedButtons] = useState(['Inverter 1'])
  const [selectedTotalGenerationButtons, setSelectedTotalGenerationButtons] =
    useState(false)
  const [open, setOpen] = useState(false)
  const [openTable, setOpenTable] = useState(false)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [value, setValue] = React.useState(0)
  const [datepickerDisable, setDatepickerDisable] = React.useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const PlantID = state?.id

  const isButtonSelected = (buttonName) => selectedButtons.includes(buttonName)

  const containsInverter = (buttonName) =>
    selectedButtons.some((item) => item.includes(buttonName))

  // Update screen size when the component mounts and when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight)
    }

    // Attach the resize event listener
    window.addEventListener('resize', handleResize)

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const getXAxisFormatter = () => {
    if (inverterviewbutton === 'day') {
      return (value) => {
        const date = dayjs(value)
        if (!date.isValid()) {
          console.warn('Invalid date in x-axis formatter:', value)
          return 'Invalid Date'
        }
        return date.format('HH:mm')
      }
    } else if (inverterviewbutton === 'MTD' || inverterviewbutton === '1M') {
      return (value) =>
        dayjs(value).isValid()
          ? dayjs(value).format('DD-MM-YYYY')
          : 'Invalid Date'
    } else if (['YTD', '1Y', '6M', '3M'].includes(inverterviewbutton)) {
      return (value) =>
        dayjs(value).isValid() ? dayjs(value).format('MM-YYYY') : 'Invalid Date'
    } else if (inverterviewbutton === 'custom') {
      const diffInHours = dayjs(technicalToDate).diff(
        dayjs(technicalFromDate),
        'hour'
      )
      return (value) => {
        const date = dayjs(value)
        return date.isValid()
          ? date.format(diffInHours <= 24 ? 'HH:mm' : 'DD-MM-YYYY')
          : 'Invalid Date'
      }
    }
    return (value) =>
      dayjs(value).isValid()
        ? dayjs(value).format('DD-MM-YYYY')
        : 'Invalid Date'
  }

  const [lineData, setLineData] = useState({
    options: {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false,
        },
        toolbar: {
          export: {
            csv: {
              filename: 'InverterView',
              columnDelimiter: ',',
              headerCategory: 'Date',
              headerValue: 'value',
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString()
              },
            },
            svg: {
              filename: 'InverterView',
            },
            png: {
              filename: 'InverterView',
            },
          },
        },
      },
      legend: {
        show: true,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'straight',
      },
      title: {
        align: 'left',
      },
      // colors: ["#6CB759", "#5968B7", "#dc3545", '#F5B041', "#BB8FCE", "#CCCCFF"],
      markers: {
        size: 2,
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        type: 'category',
        floating: false,
        tickAmount: 15,
        tickPlacement: 'on',
        labels: {
          show: true,
          rotate: -45,
          rotateAlways: true,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120,
          style: {
            colors: [],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
          },
          offsetX: 0,
          offsetY: 0,
          /*format: 'dd/MM',
          formatter: function (value) {
            return dayjs(value).format('DD/MM')
          },*/
          formatter: getXAxisFormatter(),
          datetimeUTC: false,
          /*datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM',
            hour: 'HH:mm',
          },*/
        },
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
          format: 'dd MMM',
          formatter: function (value, opts) {
            return dayjs(
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x
            ).format('DD-MMMM-YYYY')
          },
        },
        y: {
          formatter: function (value) {
            return parseFloat(value).toFixed(2) + ' kWh'
          },
        },
      },
    },
  })

  const DEVID = state?.roofDetails?.[0]?.inverters?.[0]?.inverterId // use this for Inverter graph
  console.log('DEVID: in inverterviewgraph', DEVID)

  useEffect(() => {
    if (!PlantID) {
      console.warn('plantId not found')
      return
    }
    FetchDeviceStatusNew(PlantID, token).then((response) => {
      if (response?.data) {
        const inverterCount = response.data.inverters || 1
        setInverterCount(inverterCount)
        console.log('Inverter count:', inverterCount)
      }
    })
  }, [PlantID])

  /*useEffect(() => {
    setSelectedDeviceID(DEVID)
    setSelectedButtons([`Inverter ${selectedTypeID}`])
    handleSelectInverter('Inverter', '1m', DEVID, selectedTypeID)
  }, [DEVID])*/
  useEffect(() => {
    if (state?.deviceCounts?.inverters > 0 && PlantID) {
      // Initialize with Inverter 1 only (Total Generation NOT selected)
      setSelectedDeviceID('inverter-1')
      setSelectedButtons(['Inverter 1'])
      setSelectedTypeID(1)
      setSelectedTotalGenerationButtons(false)
      setValue(0) // Set tab to first inverter
      handleSelectInverter('Inverter', '1m', 'inverter-1', 1, token)
    }
  }, [state?.deviceCounts?.inverters, PlantID])

  useEffect(() => {
    handleChangePreiod(inverterviewbutton)
  }, [
    technicalToDate,
    technicalFromDate,
    graphType,
    inverterviewbutton,
    selectedDeviceID,
    selectedTypeID,
  ])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  //for graph-v2
  /*const handleSelectInverter = (type, duration, deviceID, typeID) => {
    let subtraction
    let subType
    let TechnicalFromDate
    let TechnicalTodate

    switch (duration) {
      case 'year':
        subtraction = 11
        subType = 'month'
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case '1m':
        subtraction = 1
        subType = 'month'
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case '3m':
        subtraction = 3
        subType = 'month'
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case '6m':
        subtraction = 6
        subType = 'month'
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case 'mtd':
        subtraction = 0
        subType = 'month'
        TechnicalFromDate = technicalToDate
        TechnicalTodate = 'all'
        break
      case 'ytd':
        subtraction = 0
        subType = 'month'
        TechnicalFromDate = technicalToDate
        TechnicalTodate = 'all'
        break
      case 'day':
        subtraction = 0
        subType = 'month'
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case 'custom':
        subtraction = 0
        subType = 'month'
        TechnicalFromDate = dayjs(technicalFromDate).format('YYYY-MM-DD')
        TechnicalTodate = dayjs(technicalToDate).format('YYYY-MM-DD')
        break
      default:
        break
    }

    const sortDate = dayjs(TechnicalFromDate).format('YYYY-MM-DD')

    let DEVID

    if (type === 'etoday') {
      DEVID = 'all'
    } else if (type === 'Inverter') {
      DEVID = state?.roofDetails?.[0]?.inverters?.[0]?.inverterId
    }
    setIsLoading(true)

    FetchGraphBysortNew(
      PlantID,
      sortDate,
      duration,
      type,
      token,
      TechnicalTodate,
      'all',
      DEVID
    ).then((resp) => {
      if (resp?.data) {
        const newInverterData = resp?.data.map((obj) => ({
          x: obj.x,
          y: obj.y !== null ? Number(parseFloat(obj.y).toFixed(1)) : 0,
        }))
        let devtype
        let selectedColor
        if (type === 'etoday') {
          selectedColor = '#FFA500'
          devtype = 'TotalGeneration'
        } else if (type === 'Inverter') {
          devtype = 'Inverter'
          selectedColor = '#5968B7'
        }
        setMapinverterData(newInverterData)
        setMapInverterSeries((prevSeries) => {
          const existingObject = prevSeries.find(
            (obj) => obj.name === `${devtype} ${typeID}`
          )

          if (existingObject) {
            const updatedObject = {
              ...existingObject,
              data: newInverterData,
            }

            return prevSeries.map((obj) =>
              obj.name === `${devtype} ${typeID}` ? updatedObject : obj
            )
          } else {
            const newObject = {
              name: `${devtype} ${typeID}`,
              data: newInverterData,
              color: selectedColor,
              null: {
                connectNulls: true, // Connect null data points with lines
              },
            }
            setIsLoading(false)

            return [...prevSeries, newObject]
          }
        })
      } else {
      }
    })
  }*/

  const handleSelectInverter = async (
    type,
    duration,
    deviceID,
    typeID,
    token
  ) => {
    setIsLoading(true)

    const periodMap = {
      year: '1y',
      '1m': '1m',
      '3m': '3m',
      '6m': '6m',
      mtd: 'mtd',
      ytd: 'ytd',
      day: 'today',
      custom: 'custom',
    }

    const period = periodMap[duration] || 'today'
    let startDate, endDate

    if (duration === 'custom') {
      startDate = dayjs(technicalFromDate).format('YYYY-MM-DD')
      endDate = dayjs(technicalToDate).format('YYYY-MM-DD')
    } else {
      startDate = dayjs().format('YYYY-MM-DD')
      endDate = 'all'
    }

    //let DEVID  = '689be94e45893db3ed8b219e'
    let DEVID = state?.roofDetails?.[0]?.inverters?.[0]?.inverterId
    //DEVID = deviceID

    console.log('deviceID in handleselectinverter', DEVID)
    console.log('StartDate in handleselectinverter', startDate)
    console.log('period in handleselectinverter', period)
    console.log('Enddate in handleselectinverter', endDate)

    /*console.log(`Fetching ${type} data with params:`, {
          plantId: PlantID,
          dataType: 'invertergeneration',
          fromDate: startDate,
          period,
          toDate: endDate,
          duration,
          token,
        });*/

    try {
      // Verify token is valid before API call
      if (!token || token.trim() === '') {
        console.error('Token is invalid for handleSelectInverter')
        throw new Error('Authentication token is missing or invalid')
      }

      console.log('handleSelectInverter - API Call:', {
        type,
        duration,
        period,
        startDate,
        endDate,
        deviceID,
        typeID,
        PlantID,
      })

      const response = await fetchGraphV2Data(
        PlantID,
        'inverter',
        startDate,
        period,
        token,
        'all', // roofId
        endDate,
        'all' // deviceId
      )

      if (response && Array.isArray(response)) {
        const processedData = response.map((entry) => ({
          x: new Date(entry.x).getTime(),
          y: parseFloat(parseFloat(entry.y || 0).toFixed(2)),
        }))

        const devtype = 'Inverter'
        const selectedColor = '#5968B7'

        setMapInverterSeries((prevSeries) => {
          const existingIndex = prevSeries.findIndex(
            (obj) => obj.name === `${devtype} ${typeID}`
          )

          if (existingIndex >= 0) {
            return prevSeries.map((obj) =>
              obj.name === `${devtype} ${typeID}`
                ? { ...obj, data: processedData }
                : obj
            )
          } else {
            return [
              ...prevSeries,
              {
                name: `${devtype} ${typeID}`,
                data: processedData,
                color: selectedColor,
                null: { connectNulls: true },
              },
            ]
          }
        })
      }
    } catch (error) {
      console.error('Error fetching inverter data:', {
        error: error.message,
        status: error.response?.status,
        data: error.response?.data,
        period,
        duration,
      })
      
      // Show user-friendly error message
      if (error.response?.status === 401) {
        console.warn('Session expired - please refresh and try again')
      }
    } finally {
      setIsLoading(false)
    }
  }

  const handleSelectTotalGeneration = (type, duration) => {
    let TechnicalFromDate
    let TechnicalTodate

    switch (duration) {
      case 'year':
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case '1m':
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case '3m':
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case '6m':
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case 'mtd':
        TechnicalFromDate = technicalToDate
        TechnicalTodate = 'all'
        break
      case 'ytd':
        TechnicalFromDate = technicalToDate
        TechnicalTodate = 'all'
        break
      case 'day':
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = 'all'
        break
      case 'custom':
        TechnicalFromDate = technicalFromDate
        TechnicalTodate = dayjs(technicalToDate).format('YYYY-MM-DD')
        break
      default:
        break
    }

    const sortDate = dayjs(TechnicalFromDate).format('YYYY-MM-DD')
    let typeGraph = type === 'Inverter' ? 'Inverter' : type

    setIsLoading(true)

    FetchGraphBysortNew(
      PlantID,
      sortDate,
      duration,
      typeGraph,
      token,
      TechnicalTodate,
      'all',
      'all'
    )
      .then((resp) => {
        if (resp?.data) {
          const newInverterData = resp.data.map((obj) => ({
            x: obj.x,
            y: obj.y !== null ? Number(parseFloat(obj.y).toFixed(1)) : 0,
          }))
          let devtype = 'Total Generation'
          let selectedColor = '#FFA500'
          setMapinverterData(newInverterData)
          setMapInverterSeries((prevSeries) => {
            const existingObject = prevSeries.find(
              (obj) => obj.name === `${devtype}`
            )

            if (existingObject) {
              return prevSeries.map((obj) =>
                obj.name === `${devtype}`
                  ? { ...obj, data: newInverterData }
                  : obj
              )
            } else {
              return [
                ...prevSeries,
                {
                  name: `${devtype}`,
                  data: newInverterData,
                  color: selectedColor,
                  null: { connectNulls: true },
                },
              ]
            }
          })
        } else {
          console.error(
            'No data received from API:',
            resp?.response?.data?.message
          )
        }
      })
      .catch((error) => {
        console.error('Error fetching total generation data:', error)
      })
      .finally(() => {
        setIsLoading(false) // Always reset isLoading
      })
  }

  //for Graph-V2 API
  const handleSelectTotalGeneration2 = async (type, duration, token) => {
    setIsLoading(true)

    const periodMap = {
      year: '1y',
      '1m': '1m',
      '3m': '3m',
      '6m': '6m',
      mtd: 'mtd',
      ytd: 'ytd',
      day: 'today',
      custom: 'custom',
    }

    const period = periodMap[duration] || 'today'
    let startDate, endDate

    if (duration === 'custom') {
      startDate = dayjs(technicalFromDate).format('YYYY-MM-DD')
      endDate = dayjs(technicalToDate).format('YYYY-MM-DD')
    } else {
      startDate = dayjs().format('YYYY-MM-DD')
      endDate = 'all'
    }

    try {
      // Verify token is valid before API call
      if (!token || token.trim() === '') {
        console.error('Token is invalid for handleSelectTotalGeneration2')
        throw new Error('Authentication token is missing or invalid')
      }

      console.log('handleSelectTotalGeneration2 - API Call:', {
        type,
        duration,
        period,
        startDate,
        endDate,
      })

      const response = await fetchGraphV2Data(
        PlantID,
        'totalgeneration',
        startDate,
        period,
        token,
        'all', // roofId
        endDate,
        'all' // deviceId
      )

      if (response && Array.isArray(response)) {
        const processedData = response.map((entry) => ({
          x: new Date(entry.x).getTime(),
          y: parseFloat(parseFloat(entry.y || 0).toFixed(2)),
        }))

        if (period === 'custom') {
          processedData.sort((a, b) => a.x - b.x)
        }

        const devtype = 'Total Generation'
        const selectedColor = '#FFA500'

        setMapInverterSeries((prevSeries) => {
          const existingIndex = prevSeries.findIndex(
            (obj) => obj.name === devtype
          )

          if (existingIndex >= 0) {
            return prevSeries.map((obj) =>
              obj.name === devtype ? { ...obj, data: processedData } : obj
            )
          } else {
            return [
              ...prevSeries,
              {
                name: devtype,
                data: processedData,
                color: selectedColor,
                null: { connectNulls: true },
              },
            ]
          }
        })
      } else {
        console.warn('No data received for Total Generation')
      }
    } catch (error) {
      console.error('Error fetching Total Generation:', {
        error: error.message,
        status: error.response?.status,
        data: error.response?.data,
        period,
        duration,
      })
      
      // Show user-friendly error message
      if (error.response?.status === 401) {
        console.warn('Session expired - please refresh and try again')
      }
    } finally {
      setIsLoading(false)
    }
  }

  const handleChangePreiod = (Period) => {
    selectedButtons.forEach((item) => {
      const { label } = separateValues(item)
      let devtype
      if (label === 'Inverter') {
        devtype = 'Inverter'
        handleSelectInverter(
          devtype,
          Period,
          selectedDeviceID,
          selectedTypeID,
          token
        )
      }
    })

    //if totalgenerateion selected
    if (selectedTotalGenerationButtons) {
      handleSelectTotalGeneration2('Inverter', Period, token)
    }
  }

  const separateValues = (str) => {
    const [label, value] = str.split(' ') // Split the string into two parts using the space as a separator
    return { label, value }
  }

  /*const handleChangePreiod = (Period) => {
    selectedButtons.map((item) => {
      const { label } = separateValues(item)

      let devtype
      if (label === 'Inverter') {
        devtype = 'Inverter'
      }

      handleSelectInverter(devtype, Period, selectedDeviceID, selectedTypeID)
    })
    if (selectedTotalGenerationButtons) {
      handleSelectTotalGeneration2('Inverter', inverterviewbutton, 'all')
    }
  }*/

  const handleChooseDate = (value, type) => {
    let subtraction
    let subType

    switch (inverterviewbutton) {
      case 'year':
        subtraction = 11
        subType = 'month'
        break
      case '1m':
        subtraction = 29
        subType = 'day'
        break
      case '3m':
        subtraction = 2
        subType = 'month'
        break
      case '6m':
        subtraction = 5
        subType = 'month'
        break
      case 'mtd':
        subtraction = 0
        subType = 'month'
        break
      case 'ytd':
        subtraction = 0
        subType = 'month'
        break
      case 'day':
        subtraction = 0
        subType = 'month'
        break
      case 'custom':
        subtraction = 0
        subType = 'month'
        break
      default:
        break
    }

    if (type === 'from') {
      if (inverterviewbutton === 'custom') {
        setTechnicalFromDate(value)
      } else {
        setTechnicalFromDate(value)
        const yearData = dayjs(value).add(subtraction, subType)
        const currentDate1y = dayjs()
        const isFuture1y = yearData.isAfter(currentDate1y)
        if (isFuture1y) {
          const previous1yData = dayjs(dayjs(new Date())).subtract(
            subtraction,
            subType
          )
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
        } else {
          setTechnicalToDate(dayjs(new Date()))
        }
      }
    } else if (type === 'to') {
      if (inverterviewbutton === 'custom') {
        setTechnicalToDate(value)
      } else {
        const yearData = dayjs(value).subtract(subtraction, subType)
        setTechnicalFromDate(yearData)
        setTechnicalToDate(dayjs(new Date()))
      }
    }
  }

  const handleselectButton = (ButtonType) => {
    switch (ButtonType) {
      case 'year':
        const yearData = dayjs(technicalFromDate).add(11, 'month')
        const currentDate1y = dayjs()
        const isFuture1y = yearData.isAfter(currentDate1y)
        if (isFuture1y) {
          const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('year')
          handleChangePreiod('year')
        } else {
          const previous1yData = dayjs(dayjs(new Date())).subtract(11, 'month')
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('year')
          handleChangePreiod('year')
        }

        break
      case '1m':
        const monthData = dayjs(technicalFromDate).add(29, 'day')
        const currentDate1 = dayjs()
        const isFuture1 = monthData.isAfter(currentDate1)
        if (isFuture1) {
          const previous1Data = dayjs(dayjs(new Date())).subtract(29, 'day')
          setTechnicalFromDate(previous1Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('1m')
          handleChangePreiod('1m')
        } else {
          const previous1Data = dayjs(dayjs(new Date())).subtract(29, 'day')
          setTechnicalFromDate(previous1Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('1m')
          handleChangePreiod('1m')
        }
        break
      case '3m':
        const month3Data = dayjs(technicalFromDate).add(2, 'month')
        const currentDate = dayjs()
        const isFuture = month3Data.isAfter(currentDate)
        if (isFuture) {
          const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
          setTechnicalFromDate(previous3Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('3m')
          handleChangePreiod('3m')
        } else {
          const previous3Data = dayjs(dayjs(new Date())).subtract(2, 'month')
          setTechnicalFromDate(previous3Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('3m')
          handleChangePreiod('3m')
        }
        break
      case '6m':
        const month6Data = dayjs(technicalFromDate).add(5, 'month')
        const currentDate6 = dayjs()
        const isFuture6 = month6Data.isAfter(currentDate6)
        if (isFuture6) {
          const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
          setTechnicalFromDate(previous6Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('6m')
          handleChangePreiod('6m')
        } else {
          const previous6Data = dayjs(dayjs(new Date())).subtract(5, 'month')
          console.log(previous6Data, 'previous6Data')
          setTechnicalFromDate(previous6Data)
          setTechnicalToDate(dayjs(new Date()))
          setinverterviewbutton('6m')
          handleChangePreiod('6m')
        }
        break
      case 'mtd':
        const firstDateOfMonth = dayjs(new Date()).startOf('month')
        setTechnicalFromDate(firstDateOfMonth)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('mtd')
        handleChangePreiod('mtd')
        break
      case 'ytd':
        const firstDateOfYear = dayjs(new Date()).startOf('year')
        setTechnicalFromDate(firstDateOfYear)
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('ytd')
        handleChangePreiod('ytd')
        break
      case 'day':
        setTechnicalToDate(dayjs(new Date()))
        setinverterviewbutton('day')
        handleChangePreiod('day')
        break
      case 'custom':
        setinverterviewbutton('custom')
        handleChangePreiod('custom')
        break
      default:
        break
    }
  }

  const handleInverterViewSort = (type) => {
    if (type === 'year') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'InverterView',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'InverterView',
                },
                png: {
                  filename: 'InverterView',
                },
              },
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMM',
              formatter: function (value) {
                return dayjs(value).format('MM-YYYY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MM-YYYY')
              },
            },
            y: {
              formatter: function (value) {
                return parseFloat(value).toFixed(2) + ' kWh'
              },
            },
          },
        },
      })
      handleselectButton('year')
    } else if (type === '1m') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'InverterView',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'InverterView',
                },
                png: {
                  filename: 'InverterView',
                },
              },
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: ['#6CB759', '#5968B7'],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value) {
                return dayjs(value).format('DD-MM-YYYY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('DD-MM-YYYY')
              },
            },
            y: {
              formatter: function (value) {
                return parseFloat(value).toFixed(2) + ' kWh'
              },
            },
          },
        },
      })

      handleselectButton('1m')
    } else if (type === '3m') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'InverterView',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'InverterView',
                },
                png: {
                  filename: 'InverterView',
                },
              },
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: ['#6CB759', '#5968B7'],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMM',
              formatter: function (value) {
                return dayjs(value).format('MM-YYYY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MM-YYYY')
              },
            },
            y: {
              formatter: function (value) {
                return parseFloat(value).toFixed(2) + ' kWh'
              },
            },
          },
        },
      })

      handleselectButton('3m')
    } else if (type === '6m') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'InverterView',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'InverterView',
                },
                png: {
                  filename: 'InverterView',
                },
              },
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: ['#6CB759', '#5968B7'],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMM',
              formatter: function (value) {
                return dayjs(value).format('MM-YYYY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MMMM-YYYY')
              },
            },
            y: {
              formatter: function (value) {
                return parseFloat(value).toFixed(2) + ' kWh'
              },
            },
          },
        },
      })

      handleselectButton('6m')
    } else if (type === 'ytd') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'InverterView',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'InverterView',
                },
                png: {
                  filename: 'InverterView',
                },
              },
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: ['#6CB759', '#5968B7'],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'MMM',
              formatter: function (value) {
                return dayjs(value).format('MM-YYYY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('MM-YYYY')
              },
            },
            y: {
              formatter: function (value) {
                return parseFloat(value).toFixed(2) + ' kWh'
              },
            },
          },
        },
      })
      handleselectButton('ytd')
    } else if (type === 'mtd') {
      setDatepickerDisable(true)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'InverterView',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'InverterView',
                },
                png: {
                  filename: 'InverterView',
                },
              },
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: ['#6CB759', '#5968B7'],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value) {
                return dayjs(value).format('DD-MM-YYYY')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MM 'yyyy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
              style: {
                fontSize: '12px',
              },
            },
          },
          tickAmount: 12,

          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('DD-MMMM-YYYY')
              },
            },
            y: {
              formatter: function (value) {
                return parseFloat(value).toFixed(2) + ' kWh'
              },
            },
          },
        },
      })
      handleselectButton('mtd')
    } else if (type === 'day') {
      setDatepickerDisable(true)
      setTechnicalFromDate(dayjs(new Date()))
      setTechnicalToDate(dayjs(new Date()))
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'InverterView',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'InverterView',
                },
                png: {
                  filename: 'InverterView',
                },
              },
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: ['#6CB759', '#5968B7'],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 25,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'HH:mm',
              formatter: function (value) {
                return dayjs(value).format('HH:mm')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'HH:mm',
              formatter: function (value, opts) {
                try {
                  const dataPoint =
                    opts.w.config.series[opts.seriesIndex]?.data[
                      opts.dataPointIndex
                    ]
                  if (!dataPoint || !dataPoint.x) {
                    console.warn('Invalid data point in tooltip:', dataPoint)
                    return 'Invalid Date'
                  }
                  return dayjs(dataPoint.x).format('DD-MMMM-YYYY HH:mm')
                } catch (error) {
                  console.error('Tooltip formatter error:', error)
                  return 'Invalid Date'
                }
              },
            },
            y: {
              formatter: function (value) {
                return parseFloat(value).toFixed(2) + ' kWh'
              },
            },
          },
        },
      })
      handleselectButton('day')
    } else if (type === 'custom') {
      setDatepickerDisable(false)
      setLineData({
        options: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  filename: 'InverterView',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  },
                },
                svg: {
                  filename: 'InverterView',
                },
                png: {
                  filename: 'InverterView',
                },
              },
            },
          },
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          title: {
            align: 'left',
          },
          colors: ['#6CB759', '#5968B7'],
          markers: {
            size: 2,
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            type: 'category',
            floating: false,
            tickAmount: 15,
            tickPlacement: 'on',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
              trim: false,
              minHeight: undefined,
              maxHeight: 120,
              style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label',
              },
              offsetX: 0,
              offsetY: 0,
              format: 'dd/MM',
              formatter: function (value) {
                return dayjs(value).format('DD-MM')
              },
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'HH:mm',
              },
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: true,
              format: 'dd MMM',
              formatter: function (value, opts) {
                return dayjs(
                  opts.w.config.series[opts.seriesIndex].data[
                    opts.dataPointIndex
                  ].x
                ).format('DD-MMMM-YYYY')
              },
            },
            y: {
              formatter: function (value) {
                return parseFloat(value).toFixed(2) + ' kWh'
              },
            },
          },
        },
      })
      handleselectButton('custom')
    }
  }

  const handleButtonClick = (buttonName, deviceID, typeID) => {
    let RoofDeviceID = deviceID
    if (selectedButtons.includes(`${buttonName} ${typeID}`)) {
      setSelectedButtons(
        selectedButtons.filter((btn) => btn !== `${buttonName} ${typeID}`)
      )

      setMapInverterSeries(
        (prevSeries) =>
          prevSeries.filter((obj) => obj.name !== `${buttonName} ${typeID}`) // Specify the name of the object to remove
      )
    } else {
      // If the button is not selected, check if the limit of 2 buttons is reached
      // if (selectedButtons.length < 2) {
      // Add the button to the selected buttons
      setSelectedButtons([...selectedButtons, `${buttonName} ${typeID}`])
      setSelectedDeviceID(deviceID)
      setSelectedTypeID(typeID)
      let devtype
      if (buttonName === 'Inverter') {
        devtype = 'Inverter'
        RoofDeviceID = deviceID
      } else if (buttonName === 'TotalGeneration') {
        devtype = 'etoday'
        RoofDeviceID = deviceID
      }
      setGraphType(devtype)
      handleSelectInverter(devtype, inverterviewbutton, RoofDeviceID, typeID, token)
    }
  }

  const handleButtonClickTotalEnergy = (selectedTotalGeneration) => {
    setSelectedTotalGenerationButtons(selectedTotalGeneration)

    if (selectedTotalGeneration !== true) {
      setMapInverterSeries(
        (prevSeries) =>
          prevSeries.filter((obj) => obj.name !== `Total Generation`) // Specify the name of the object to remove
      )
    } else {
      handleSelectTotalGeneration2('Inverter', inverterviewbutton, token)
    }
  }

  // const exportToCSV = (rows) => {
  //   console.log("Exporting to CSV with rows:", rows);

  //   const headings = ['Date', ...rows.map((item) => item.name)] // Add 'Date' and 'name' properties as headings
  //   const csvContent = [headings.join(',')]

  //   const allDates = new Set()
  //   rows.forEach((item) =>
  //     item.data.forEach((row) =>
  //       allDates.add(dayjs(row.x).format('DD-MM-YYYY'))
  //     )
  //   )

  //   allDates.forEach((date) => {
  //     const rowData = [date]
  //     rows.forEach((item) => {
  //       const dataForDate = item.data.find(
  //         (row) => dayjs(row.x).format('YYYY/MM/DD') === date
  //       )
  //       rowData.push(dataForDate ? dataForDate.y : 0)
  //     })
  //     csvContent.push(rowData.join(','))
  //   })

  //   const blob = new Blob([csvContent.join('\n')], {
  //     type: 'text/csv;charset=utf-8',
  //   })
  //   saveAs(blob, 'InverterView.csv')
  // }

  const exportToCSV = (rows) => {
    console.log('Exporting to CSV with rows:', rows)

    const headings = ['Date', ...rows.map((item) => item.name)] // Add 'Date' and 'name' properties as headings
    const csvContent = [headings.join(',')]

    // Collect all unique dates and sort them
    const allDates = new Set()
    rows.forEach((item) =>
      item.data.forEach((row) =>
        allDates.add(dayjs(row.x).format('DD-MM-YYYY'))
      )
    )

    // Convert Set to Array and sort dates
    const sortedDates = Array.from(allDates).sort((a, b) => {
      return dayjs(a, 'DD-MM-YYYY').valueOf() - dayjs(b, 'DD-MM-YYYY').valueOf()
    })

    // Process each date
    sortedDates.forEach((date) => {
      const rowData = [date]
      rows.forEach((item) => {
        // Find data for this specific date
        const dataForDate = item.data.find(
          (row) => dayjs(row.x).format('DD-MM-YYYY') === date
        )
        rowData.push(dataForDate ? dataForDate.y : 0)
      })
      csvContent.push(rowData.join(','))
    })

    const blob = new Blob([csvContent.join('\n')], {
      type: 'text/csv;charset=utf-8',
    })
    saveAs(blob, 'InverterView.csv')
  }

  const datePickerStyle = {
    width: '130px',
  }

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const dynamicHeadings = mapInverterSeries.map((item) => item.name)
  return (
    <div className={classes.root}>
      <div
        className="graph_bg mb_10"
        style={{ minHeight: '510px', backgroundColor: 'white' }}
      >
        <div className="align_btw mb_6">
          <div>
            <div className="h_txt1">Inverter View</div>
          </div>

          <div>
            <div className="align_end">
              <div class="check_graph mr_8">
                <input
                  id="InverterViewGraph"
                  type="checkbox"
                  checked={openTable}
                  onChange={() => setOpenTable(!openTable)}
                />
                <label for="InverterViewGraph"></label>
              </div>
              <div className="mr_8">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <div style={datePickerStyle}>
                      <DatePicker
                        style={{ width: '120px !important' }}
                        label="From Date"
                        minDate={dayjs(new Date()).subtract(2, 'year')}
                        maxDate={
                          inverterviewbutton === 'custom'
                            ? technicalToDate
                            : dayjs()
                        }
                        className={classes.datePicker}
                        format="DD-MM-YYYY"
                        value={technicalFromDate}
                        onChange={(value) => handleChooseDate(value, 'from')}
                        disabled={datepickerDisable}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className="mr_8">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <div style={datePickerStyle}>
                      <DatePicker
                        style={{ width: '120px !important' }}
                        label="To Date"
                        minDate={
                          inverterviewbutton === 'custom'
                            ? technicalFromDate
                            : dayjs(new Date()).subtract(2, 'year')
                        }
                        maxDate={dayjs()}
                        className={classes.datePicker}
                        format="DD-MM-YYYY"
                        value={technicalToDate}
                        onChange={(value) => handleChooseDate(value, 'to')}
                        disabled={datepickerDisable}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              </div>

              {openTable && (
                <div className="mr_8">
                  <VerticalAlignBottomIcon
                    className="i_clr pointer"
                    onClick={() => exportToCSV(mapInverterSeries)}
                  />
                </div>
              )}
              <div>
                <FullscreenIcon
                  className="i_clr pointer"
                  onClick={handleOpen}
                />
              </div>

              <Dialog fullScreen open={open} onClose={handleClose}>
                <IconButton
                  onClick={handleClose}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogTitle></DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    <div className="graph_bg">
                      <div className="align_btw mb_10">
                        <div>
                          <div className="h1">Inverter View</div>
                        </div>

                        <div className={classes.root}>
                          <div className="align_end">
                            <div class="check_graph mr_8">
                              <input
                                id="InverterViewGraph2"
                                type="checkbox"
                                checked={openTable}
                                onChange={() => setOpenTable(!openTable)}
                              />
                              <label for="InverterViewGraph2"></label>
                            </div>
                            <div className="mr_8">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                    label="From Date"
                                    minDate={dayjs(new Date()).subtract(
                                      2,
                                      'year'
                                    )}
                                    maxDate={
                                      inverterviewbutton === 'custom'
                                        ? technicalToDate
                                        : dayjs()
                                    }
                                    className={classes.largedatePicker}
                                    format="DD-MM-YYYY"
                                    value={technicalFromDate}
                                    onChange={(value) =>
                                      handleChooseDate(value, 'from')
                                    }
                                    disabled={datepickerDisable}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>
                            <div className="mr_8">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                    label="To Date"
                                    minDate={
                                      inverterviewbutton === 'custom'
                                        ? technicalFromDate
                                        : dayjs(new Date()).subtract(2, 'year')
                                    }
                                    maxDate={dayjs()}
                                    className={classes.largedatePicker}
                                    format="DD-MM-YYYY"
                                    value={technicalToDate}
                                    onChange={(value) =>
                                      handleChooseDate(value, 'to')
                                    }
                                    disabled={datepickerDisable}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </div>

                            {openTable && (
                              <div className="mr_8">
                                <VerticalAlignBottomIcon
                                  className="i_clr pointer"
                                  onClick={() => exportToCSV(mapInverterSeries)}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="align_btw mb_10">
                        <div
                          className={classes.root}
                          style={{
                            width: '30%',
                            display: 'flex',
                            flexDirection: 'row',
                          }}
                        >
                          {/* <div> */}

                          <Box
                            sx={{
                              maxWidth: { xs: 220, sm: 550 },
                              bgcolor: 'background.paper',
                            }}
                          >
                            <Tabs
                              value={value}
                              onChange={handleChange}
                              variant="scrollable"
                              scrollButtons="auto"
                              aria-label="scrollable auto tabs 2"
                            >
                              {Array.from(
                                { length: inverterCount },
                                (_, index) => (
                                  <Tab
                                    key={index}
                                    label={`Inverter ${index + 1}`}
                                    {...a11yProps(index + 10)}
                                    style={
                                      isButtonSelected(`Inverter ${index + 1}`)
                                        ? {
                                            backgroundColor:
                                              'rgb(89 104 183 / 50%)',
                                            textTransform: 'none',
                                            height: '5px',
                                          }
                                        : { 
                                            textTransform: 'none',
                                            backgroundColor: '#f0f0f0',
                                            height: '25px',
                                          }
                                    }
                                    onClick={() =>
                                      handleButtonClick(
                                        `Inverter`,
                                        `inverter-${index + 1}`,
                                        index + 1
                                      )
                                    }
                                  />
                                )
                              )}
                              <Tab
                                label={`Total Generation`}
                                style={
                                  selectedTotalGenerationButtons === true
                                    ? {
                                        backgroundColor:
                                          'rgb(89 104 183 / 50%)',
                                        textTransform: 'none',
                                        color: 'black',
                                        height: '5px',
                                      }
                                    : {
                                        backgroundColor: '#f0f0f0',
                                        fontSize: '13px',
                                        color: 'black',
                                        textTransform: 'none',
                                        height: '25px',
                                      }
                                }
                                onClick={() =>
                                  handleButtonClickTotalEnergy(
                                    !selectedTotalGenerationButtons
                                  )
                                }
                              />
                            </Tabs>
                          </Box>
                        </div>
                        <div>
                          <div
                            className={
                              inverterviewbutton === 'custom'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('custom')}
                          >
                            CUST
                          </div>
                          <div
                            className={
                              inverterviewbutton === 'ytd'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('ytd')}
                          >
                            YTD
                          </div>
                          <div
                            className={
                              inverterviewbutton === 'mtd'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('mtd')}
                          >
                            MTD
                          </div>
                          <div
                            className={
                              inverterviewbutton === 'year'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('year')}
                          >
                            1 Y
                          </div>
                          <div
                            className={
                              inverterviewbutton === '6m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('6m')}
                          >
                            6 M
                          </div>
                          <div
                            className={
                              inverterviewbutton === '3m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('3m')}
                          >
                            3 M
                          </div>
                          <div
                            className={
                              inverterviewbutton === '1m'
                                ? 'day_s_bottomline'
                                : 'day_s_b '
                            }
                            onClick={() => handleInverterViewSort('1m')}
                          >
                            1 M
                          </div>
                          {containsInverter(`Inverter`) && (
                            <div
                              className={
                                inverterviewbutton === 'day'
                                  ? 'day_s_bottomline'
                                  : 'day_s_b '
                              }
                              onClick={() => handleInverterViewSort('day')}
                            >
                              Today
                            </div>
                          )}
                        </div>
                      </div>
                      {openTable ? (
                        <div style={{ maxHeight: '360px', overflow: 'auto' }}>
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Date</TableCell>
                                  {dynamicHeadings?.map((heading, index) => (
                                    <TableCell key={index}>{heading}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {mapInverterSeries?.[0]?.data.map(
                                  (row, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                      <TableCell>
                                        {dayjs(row.x).format('DD-MM-YYYY')}
                                      </TableCell>
                                      {mapInverterSeries?.map((item, index) => (
                                        <TableCell key={index}>
                                          {parseFloat(
                                            (
                                              item.data.find(
                                                (entry) => entry.x === row.x
                                              )?.y || 0
                                            ).toFixed(2)
                                          )}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      ) : (
                        <div>
                          <div>
                            <div
                              style={{
                                color: '#5968B7',
                                fontSize: '12px',
                                marginLeft: '5px',
                              }}
                            >
                              kWh
                            </div>
                          </div>
                          <div id="chart">
                            <ReactApexChart
                              options={lineData.options}
                              series={mapInverterSeries}
                              legend={lineData.legend}
                              type="line"
                              height={screenHeight - 200}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>

        <div className="align_btw mb_6">
          <div className=" ">
            <Box
              sx={{
                maxWidth: { xs: 220, sm: 250 },
                bgcolor: 'background.paper',
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs 1"
              >
                {Array.from({ length: inverterCount }, (_, index) => (
                  <Tab
                    key={index}
                    label={`Inverter ${index + 1}`}
                    {...a11yProps(index + 10)}
                    style={
                      isButtonSelected(`Inverter ${index + 1}`)
                        ? {
                            backgroundColor: 'rgb(89 104 183 / 50%)',
                            textTransform: 'none',
                            height: '5px',
                          }
                        : { 
                            textTransform: 'none',
                            backgroundColor: '#f0f0f0',
                            height: '25px',
                          }
                    }
                    onClick={() =>
                      handleButtonClick(
                        `Inverter`,
                        `inverter-${index + 1}`,
                        index + 1
                      )
                    }
                  />
                ))}
                <Tab
                  label={`Total Generation`}
                  // {...a11yProps(3)}
                  style={
                    selectedTotalGenerationButtons === true
                      ? {
                          backgroundColor: 'rgb(89 104 183 / 50%)',
                          textTransform: 'none',
                          color: 'black',
                          height: '5px',
                        }
                      : {
                          backgroundColor: '#f0f0f0',
                          color: 'black',
                          textTransform: 'none',
                          height: '25px',
                        }
                  }
                  onClick={() =>
                    handleButtonClickTotalEnergy(
                      !selectedTotalGenerationButtons
                    )
                  }
                />
              </Tabs>
            </Box>
          </div>

          <div>
            <div
              className={
                inverterviewbutton === 'custom'
                  ? 'day_s_bottomline'
                  : 'day_s_b '
              }
              onClick={() => handleInverterViewSort('custom')}
            >
              CUST
            </div>
            <div
              className={
                inverterviewbutton === 'ytd' ? 'day_s_bottomline' : 'day_s_b '
              }
              onClick={() => handleInverterViewSort('ytd')}
            >
              YTD
            </div>
            <div
              className={
                inverterviewbutton === 'mtd' ? 'day_s_bottomline' : 'day_s_b '
              }
              onClick={() => handleInverterViewSort('mtd')}
            >
              MTD
            </div>
            <div
              className={
                inverterviewbutton === 'year' ? 'day_s_bottomline' : 'day_s_b '
              }
              onClick={() => handleInverterViewSort('year')}
            >
              1 Y
            </div>
            <div
              className={
                inverterviewbutton === '6m' ? 'day_s_bottomline' : 'day_s_b '
              }
              onClick={() => handleInverterViewSort('6m')}
            >
              6 M
            </div>
            <div
              className={
                inverterviewbutton === '3m' ? 'day_s_bottomline' : 'day_s_b '
              }
              onClick={() => handleInverterViewSort('3m')}
            >
              3 M
            </div>
            <div
              className={
                inverterviewbutton === '1m' ? 'day_s_bottomline' : 'day_s_b '
              }
              onClick={() => handleInverterViewSort('1m')}
            >
              1 M
            </div>
            {containsInverter(`Inverter`) && (
              <div
                className={
                  inverterviewbutton === 'day' ? 'day_s_bottomline' : 'day_s_b '
                }
                onClick={() => handleInverterViewSort('day')}
              >
                Today
              </div>
            )}
          </div>
        </div>

        {isLoading ? (
          <div
            style={{
              padding: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
              marginTop: '100px',
            }}
          >
            <LinearBuffer />
          </div>
        ) : openTable ? (
          <div style={{ maxHeight: '360px', overflow: 'auto' }}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    {dynamicHeadings?.map((heading, index) => (
                      <TableCell key={index}>{heading}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mapInverterSeries?.[0]?.data.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell>{dayjs(row.x).format('DD-MM-YYYY')}</TableCell>
                      {mapInverterSeries?.map((item, index) => (
                        <TableCell key={index}>
                          {parseFloat(
                            (
                              item.data.find((entry) => entry.x === row.x)?.y ||
                              0
                            ).toFixed(2)
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : (
          <div>
            <div>
              <div
                style={{
                  color: '#5968B7',
                  fontSize: '12px',
                  marginLeft: '5px',
                }}
              >
                kWh
              </div>
            </div>
            <div id="chart">
              <ReactApexChart
                options={lineData.options}
                series={mapInverterSeries}
                legend={lineData.legend}
                type="line"
                height={385}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default InverterViewGraph
